import Breadcrumb from "../components/Breadcrumb";
import ViewClientLayer from "../components/ViewClientlayer";

const ViewClientPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="View Client" />

      < ViewClientLayer/>
    </>
  );
};

export default ViewClientPage;
